import React from 'react';
import { context, LocaleContextType } from './LocaleContext';

export const LocaleProvider = ({
  value,
  children,
}: {
  value: LocaleContextType;
  children: React.ReactNode;
}) => {
  return <context.Provider value={value}>{children}</context.Provider>;
};
